export default __webpack_public_path__ + "static/media/technical-head.63aab65e.jpg";